import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React from "react";
import {useNavigate} from "react-router-dom";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {config} from "../../../constant";

export default function DialogEditCategory({open, onClose, category}) {
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Nom est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: category ? {
            id: category.id,
            name: category.name
        } : {
            name: ''
        }
    });

    const onSubmit = (data) => {
        const requestOptions = {
            method: category ? 'PUT' : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        fetch(`${config.BASE_URL}/categories`, requestOptions)
            .then(response => {
                onClose(true);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch((error) => {
                const message = 'Erreur dans la création ou mise à jour d\'une catégorie';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth={'lg'}>
            <DialogTitle>Catégorie</DialogTitle>
            <DialogContent>
                <form id="categoryForm" onSubmit={handleSubmit(onSubmit)}>
                    <TextField
                        margin="dense"
                        id="name"
                        name="name"
                        label="Nom"
                        fullWidth
                        variant="standard"
                        {...register("name")}
                        error={!!errors.name}
                    />
                    <Typography variant="inherit" color="textSecondary">{errors.name?.message}</Typography>
                </form>
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="categoryForm">OK</Button>
                <Button onClick={() => onClose(false)}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
